import visit from 'unist-util-visit-parents';
import { getHeadingTextForId } from '../utils';

/**
 * A plugin that adds to heading nodes the ids.
 * Supports markdown headings only! (doesn't support html heading elements).
 */

const shouldVisitNode = (node) => node.type === 'heading';

export function githubSluggify() {
  function transformer(tree) {
    const headingIdCounter = {};
    const updateHeadingIdCounter = (id) => {
      if (headingIdCounter[id] === undefined) {
        headingIdCounter[id] = 0;
      } else {
        headingIdCounter[id] += 1;
      }
    };

    visit(tree, shouldVisitNode, githubSluggifyTree);

    function githubSluggifyTree(node, ancestors) {
      const start = node;
      const parent = ancestors[ancestors.length - 1];
      const startIndex = parent.children.indexOf(start);

      const headingId = getHeadingTextForId(node);

      updateHeadingIdCounter(headingId);

      const nodeId = headingIdCounter[headingId]
        ? `${headingId}-${headingIdCounter[headingId]}`
        : headingId;

      parent.children[startIndex] = {
        ...node,
        id: nodeId, // The nodeId is passed here for the sectionize plugin later on, so that the section of the heading will take the correct id.
        value: nodeId, // The nodeId is passed also to `value` because 'react-markdown' doesn't pass down to the custom renderers the prop 'id' but 'value'.
      };
    }
    return tree;
  }

  return transformer;
}
